import { render } from "./ScoreHBHT.vue?vue&type=template&id=1a5baca2&scoped=true"
import script from "./ScoreHBHT.vue?vue&type=script&lang=js"
export * from "./ScoreHBHT.vue?vue&type=script&lang=js"

import "./ScoreHBHT.vue?vue&type=style&index=0&id=1a5baca2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5baca2"]])

export default __exports__